import { useState } from "react";
import { Link, Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { login, setToken } from "../api";
import { AssetLibrary } from "./AssetLibrary";
import { CaseEditor } from "./CaseEditor";
import { CaseList } from "./CaseList";
import { PmProjectImport } from "./PmProjectImport";

export function AdminApp({ initialLogin = false }: { initialLogin?: boolean }) {
  const [needsLogin, setNeedsLogin] = useState(initialLogin);
  const location = useLocation();
  const navigate = useNavigate();
  if (needsLogin) return <Login onSuccess={() => { setNeedsLogin(false); navigate("/admin/cases"); }} />;
  return <div className="admin-shell">
    <aside className="admin-sidebar">
      <Link to="/" className="admin-brand">微会务<strong>内容中台</strong></Link>
      <nav>
        <Link className={location.pathname.includes("/cases") ? "active" : ""} to="/admin/cases">案例管理</Link>
        <Link className={location.pathname.includes("/pm-projects") ? "active" : ""} to="/admin/pm-projects">PM 项目</Link>
        <Link className={location.pathname.includes("/assets") ? "active" : ""} to="/admin/assets">素材中心</Link>
      </nav>
      <button onClick={() => { setToken(null); setNeedsLogin(true); }}>退出登录</button>
    </aside>
    <main className="admin-main"><Routes>
      <Route path="cases" element={<CaseList />} />
      <Route path="cases/new" element={<CaseEditor />} />
      <Route path="cases/:id" element={<CaseEditor />} />
      <Route path="pm-projects" element={<PmProjectImport />} />
      <Route path="assets" element={<AssetLibrary />} />
      <Route path="*" element={<Navigate to="cases" replace />} />
    </Routes></main>
  </div>;
}

function Login({ onSuccess }: { onSuccess: () => void }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  async function submit(event: React.FormEvent) {
    event.preventDefault(); setError("");
    try { const result = await login(username, password); setToken(result.token); onSuccess(); }
    catch { setError("账号或密码错误"); }
  }
  return <main className="login-shell"><form onSubmit={submit} className="login-card">
    <span className="eyebrow">CONTENT PLATFORM</span><h1>案例与素材管理</h1><p>登录后可管理案例草稿、发布状态与真实项目素材。</p>
    <label>账号<input value={username} onChange={(event) => setUsername(event.target.value)} autoComplete="username" /></label>
    <label>密码<input type="password" value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="current-password" /></label>
    {error && <p className="form-error">{error}</p>}<button className="primary-button" type="submit">登录</button>
    <Link to="/">返回公开案例中心</Link>
  </form></main>;
}
